var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h1',[_c('textloader-component',{attrs:{"textKey":"EngageraDigRubrik"}})],1),_c('p',[_c('textloader-component',{attrs:{"textKey":"EngageraDigBrödtext"}})],1),_c('v-img',{staticClass:"center",attrs:{"src":require('@/assets/Aktuellt/EngageraDig/engagera_dig.jpg'),"max-width":"100%"}}),_c('br')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }